import { render, staticRenderFns } from "./BuildingPositionsReadOnly.vue?vue&type=template&id=4c193e4c&scoped=true"
import script from "./BuildingPositionsReadOnly.vue?vue&type=script&lang=js"
export * from "./BuildingPositionsReadOnly.vue?vue&type=script&lang=js"
import style0 from "./BuildingPositionsReadOnly.vue?vue&type=style&index=0&id=4c193e4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c193e4c",
  null
  
)

export default component.exports